import authHeader from './auth-header';
import API from '@/services/base';

class PaisesService {
    get() {
        return API.get(`/paises`, { headers: authHeader() }).then(res => {
            return res.data;
        });
    }
}

export default new PaisesService();
